<template>
  <div class="bottomVert" v-if="detailReseauxTempo.listeFaces.length">
    <gmap-map
      class="infoBorder gmapMobile"
      :center="{
        lat: detailReseauxTempo.latitude,
        lng: detailReseauxTempo.longitude
      }"
      :zoom="12"
      :options="{
        mapTypeControlOptions: mapType,
      }"
      ref="map"
      @tilesloaded="initCarto">
      <gmap-marker
        v-for="(m, index) in detailReseauxTempo.listeFaces"
        :key="index"
        :clickable="true"
        :position="{
          lat: m.latitude,
          lng: m.longitude
        }"
        @click="detailFace = m, show = true"
        :icon="icon(detailReseauxTempo.couleur, m)">
      </gmap-marker>
      <gmap-marker
        v-if="markerReseauxTempo.lat"
        :position="{
          lat: markerReseauxTempo.lat,
          lng: markerReseauxTempo.lng,
        }"
        :icon="markerReseauxTempo.icon">
      </gmap-marker>
    </gmap-map>
    <app-detail-tempo :detailFace="detailFace" v-if="show"/>
  </div>
</template>

<script>
import { iconColorGetter, TAILLE_ICON_GRAND, TAILLE_ICON_PETIT } from '@/services/general/iconColorGetter';
import {
  MAP_TYPE_CONTROL_OPTIONS,
  STYLE_MAPS_POI_HIDDEN, MAP_TYPE_NAME,
} from '@/configurations/configurationCarto';
import filterLatLng from '@/services/general/gestionLatLng';
import detailTempo from './detailTempo';

export default {
  name: 'carteReseauxTempo',
  components: {
    appDetailTempo: detailTempo,
  },
  props: ['detailReseauxTempo', 'markerReseauxTempo'],
  data() {
    return {
      detailFace: {},
      show: false,
      colorIcon: '#49db70',
      bg: false,
      mapType: MAP_TYPE_CONTROL_OPTIONS,
      isLoadOnce: false,
    };
  },
  methods: {
    async levelZoom() {
      const map = await this.$refs.map.$mapPromise;
      const bounds = new google.maps.LatLngBounds();
      filterLatLng(this.detailReseauxTempo.listeFaces);
      this.detailReseauxTempo.listeFaces.forEach(m => {
        if (m.latitude !== 0 && m.longitude !== 0
        && m.latitude !== null && m.longitude !== null) {
          bounds.extend({ lat: m.latitude, lng: m.longitude });
        }
      });
      if (this.markerReseauxTempo !== undefined && this.markerReseauxTempo.lat !== undefined) {
        bounds.extend({ lat: this.markerReseauxTempo.lat, lng: this.markerReseauxTempo.lng });
      }
      map.fitBounds(bounds);
    },
    icon(color, face) {
      if (face.codeFormat === '4' || face.codeFormat === '3') {
        if (!color) return iconColorGetter(this.colorIcon, TAILLE_ICON_GRAND, face.azimut, true);
        return iconColorGetter(color, TAILLE_ICON_GRAND, face.azimut, true);
      }
      if (!color) return iconColorGetter(this.colorIcon, TAILLE_ICON_PETIT, face.azimut, true);
      return iconColorGetter(color, TAILLE_ICON_PETIT, face.azimut, true);
    },
    async initPoi() {
      const map = await this.$refs.map.$mapPromise;
      const styleMap = new google.maps.StyledMapType(STYLE_MAPS_POI_HIDDEN, {
        name: MAP_TYPE_NAME,
      });
      map.mapTypes.set('styled_map', styleMap);
    },
    async initCarto() {
      if (!this.isLoadOnce) {
        await this.initPoi();
        if (this.detailReseauxTempo.listeFaces.length) {
          await this.levelZoom();
        }
        this.isLoadOnce = true;
      }
    },
  },
  mounted() {
    if (this.detailReseauxTempo.latitude === null || this.detailReseauxTempo.longitude === null) {
      this.detailReseauxTempo.latitude = 0;
      this.detailReseauxTempo.longitude = 0;
    }
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/reseauxTempo/carteReseauxTempo.vue